import { motion } from "framer-motion";
import { forwardRef } from "react";

const Card = forwardRef(
  ({ children, className = "", hover = true, ...props }, ref) => {
    return (
      <motion.div
        ref={ref}
        className={`bg-white rounded-3xl p-6 shadow-soft transition-all duration-300 overflow-hidden ${
          hover ? "hover:shadow-soft-lg hover:-translate-y-1" : ""
        } ${className}`}
        whileHover={hover ? { y: -4 } : {}}
        {...props}
      >
        {children}
      </motion.div>
    );
  }
);

Card.displayName = "Card";

export default Card;

